import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd';
import { _HttpClient, ALAIN_I18N_TOKEN } from '@delon/theme';
import { environment } from '@env/environment';
import { I18NService } from '@core/i18n/i18n.service';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';

/**
 * 默认HTTP拦截器，其注册细节见 `app.module.ts`
 */
@Injectable()
export class DefaultInterceptor implements HttpInterceptor {
  constructor(private injector: Injector,
              @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
              private message: NzMessageService,
              @Inject(ALAIN_I18N_TOKEN) private i18NService: I18NService
  ) {
  }

  get msg(): NzMessageService {
    return this.injector.get(NzMessageService);
  }

  private goTo(url: string) {
    setTimeout(() => this.injector.get(Router).navigateByUrl(url));
  }

  private handleData(event: any | HttpErrorResponse): Observable<any> {
    // 可能会因为 `throw` 导出无法执行 `_HttpClient` 的 `end()` 操作
    this.injector.get(_HttpClient).end();
    if(event.error&&event.error.message=='-UnauthorizedIllegalOperation-BySourcing-'){
      this.message.error(`错误的权限操作`);
      this.goTo('/supplier-portal/home-page');
      return throwError(event);
    }
    // 业务处理：一些通用操作
    switch (event.status) {
      case 200:
        // 业务层级错误处理，以下是假定restful有一套统一输出格式（指不管成功与否都有相应的数据格式）情况下进行处理
        // 例如响应内容：
        //  错误内容：{ status: 1, msg: '非法参数' }
        //  正确内容：{ status: 0, response: {  } }
        // 则以下代码片断可直接适用
        // if (event instanceof HttpResponse) {
        //     const body: any = event.body;
        //     if (body && body.status !== 0) {
        //         this.msg.error(body.msg);
        //         // 继续抛出错误中断后续所有 Pipe、subscribe 操作，因此：
        //         // this.http.get('/').subscribe() 并不会触发
        //         return throwError({});
        //     } else {
        //         // 重新修改 `body` 内容为 `response` 内容，对于绝大多数场景已经无须再关心业务状态码
        //         return of(new HttpResponse(Object.assign(event, { body: body.response })));
        //         // 或者依然保持完整的格式
        //         return of(event);
        //     }
        // }
        break;
      case 400: // 未登录状态码
        this.tokenService.clear();
        if(event.error && event.error.message){
          this.message.error(`${event.error.message}`);
        }
        return throwError(event);
      case 401: // 未登录状态码
        this.tokenService.clear();
        this.goTo('/passport/login');
        break;
      case 403:
        this.message.error('无权限操作');
        // if(event.error && event.error.message){
        //   this.message.error(`${event.error.message}`);
        // }
        return throwError(event);
        //this.goTo(`/${event.status}`);
        break;
      case 404:
      case 500:
        if(event.error && event.error.message){
          this.message.error(`${event.error.message}`);
        }
        return throwError(event);
      case 602: // curd错误
        if(event.error && event.error.message){
          this.message.error(`${event.error.message}`);
        }
        return throwError(event);
      //break;
      case 702: // 系统未授权
        this.goTo('/license');
        break;
      default:
        if (event instanceof HttpErrorResponse) {
          console.warn(
            '未可知错误，大部分是由于后端不支持CORS或无效配置引起',
            event,
          );
          this.msg.error(event.message);
          return throwError(event);
        }
        break;
    }
    return of(event);
  }

  intercept(req: HttpRequest<any>,
            next: HttpHandler,): Observable<| HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    // 统一加上服务端前缀
    let url = req.url;

    if (url.startsWith('jysip/') || url.startsWith('/jysip/')) {
      url = environment.SIP_SERVER_URL + url.replace('/jysip/', '').replace('jysip/', '');
    }
    else if (!url.startsWith('https://') && !url.startsWith('http://') && !url.startsWith("assets") && !url.startsWith("/assets")) {
      url = environment.SERVER_URL + url;
    }


    let headers = req.headers;
    headers = headers.set('Language', this.i18NService.currentLang);
    let timeZone = new Date().getTimezoneOffset() / (-60);
    headers = headers.set('TimeZone', 'UTC' + (timeZone < 0 ? '' + timeZone : '+' + timeZone));

    const newReq = req.clone({
      url: url,
      headers: headers
    });
    return next.handle(newReq).pipe(
      mergeMap((event: any) => {
        // 允许统一对请求错误处理，这是因为一个请求若是业务上错误的情况下其HTTP请求的状态是200的情况下需要
        if (event instanceof HttpResponse && event.status === 200)
          return this.handleData(event);
        // 若一切都正常，则后续操作
        return of(event);
      }),
      catchError((err: HttpErrorResponse) => this.handleData(err)),
    );
  }
}
